export default __webpack_public_path__ + "static/media/measures1.e051ca41.png";